import { NgModule } from '@angular/core';
import { RemoveHostDirective } from './remove-host/remove-host';
@NgModule({
	declarations: [RemoveHostDirective],
	imports: [],
	exports: [RemoveHostDirective]
})
export class DirectivesModule {}
